// extracted by mini-css-extract-plugin
export default {"note":"Note_note__VKtbj","use-custom-scrollbar":"Note_use-custom-scrollbar__BZyLo"};